class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    // Guard: Shopify renders TWO <facet-filters-form> elements (desktop + mobile).
    // Constructor fires once per element — this flag ensures setup runs only ONCE.
    if (!FacetFiltersForm.initialized) {
      FacetFiltersForm.initialized = true;

      FacetFiltersForm.sortProductGridOnLoad();
      FacetFiltersForm.renderProductCount();

      // BUILD IMMUTABLE CACHE FROM RAW PRODUCT SOURCE (runs once only)
      FacetFiltersForm.initializeMasterLayoutCache();
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.availabilityCountCache = null;
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));

    const gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer && gridContainer.querySelector('.collection')) {
      gridContainer.querySelector('.collection').classList.add('loading');
    }
    if (countContainer) countContainer.classList.add('loading');
    if (countContainerDesktop) countContainerDesktop.classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
         setTimeout(function(){
            $(".product-grid li.grid__item").each(function() {
                var text = '';
               $(this).find(".main-collection-variants .product-form__input input").each(function(){
                   if ($(this).is(":checked"))
                  {
                    text += $(this).val()+" / ";
                  }
               });
                 var newname = text.slice(0,-2).trim();
               var get_data_sku = $(this).find(".main-collection-variants .hidden-collection-variants option[value='"+newname+"']").attr("data-sku");
                var get_data_image = $(this).find(".main-collection-variants .hidden-collection-variants option[value='"+newname+"']").attr("variant-image");
                var get_data_avail = $(this).find(".main-collection-variants .hidden-collection-variants option[value='"+newname+"']").attr("variants-avail");
                var get_data_id = $(this).find(".main-collection-variants .hidden-collection-variants option[value='"+newname+"']").attr("variant-id");
                var get_data_url = $(this).find(".main-collection-variants .hidden-collection-variants option[value='"+newname+"']").attr("variant-url");
                $(this).find(".card__information .sku_custom_html").html(get_data_sku);
                $(this).find(".card--media .card__media img").attr("src",get_data_image);
                $(this).find(".card--media .card__media img").attr("srcset",get_data_image);
                $(this).find(".card--media .card__media a").attr("href",get_data_url);
                $(this).find(".card__information a").attr("href",get_data_url);
                if(get_data_avail == 'false'){
                     $(this).find(".card--media .card__badge-soldout").show();
                  $(this).find(".card--media .card__badge-soldout .out_of_stock_plugin_coll").show();
                  $(this).find(".card--media .card__badge-soldout .only_badges_wrapp").html("<span class='badge badge--bottom-left sold-out-badge'>Sold Out</span>");
                  $(this).find(".card--media .card__badge-soldout .out_of_stock_plugin_coll").attr("data-vid",get_data_id);
                  $(this).find(".card--media .card__badge-soldout .out_of_stock_plugin_coll").attr("data-sku",get_data_sku);
                }else{
                 $(this).find(".card--media .card__badge-soldout").hide();
                }
            });
            FacetFiltersForm.applyVariantLevelFilters();
          },100);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderProductGridContainer(html) {
    const gridContainer = document.getElementById('ProductGridContainer');
    if (!gridContainer) return;

    gridContainer.innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    FacetFiltersForm.sortProductGridOnLoad();

    gridContainer.querySelectorAll('.scroll-trigger').forEach((element) => {
      element.classList.add('scroll-trigger--cancel');
    });

    FacetFiltersForm.updateCheckboxFacetCounts();
  }

  static sortProductGridOnLoad() {
    const gridContainer = document.getElementById('ProductGridContainer');
    if (!gridContainer) return;

    const urlParams = new URLSearchParams(window.location.search);
    const sortBy = urlParams.get('sort_by');

    if (sortBy === 'price-ascending' || sortBy === 'price-descending') {
      const productUl = gridContainer.querySelector('#product-grid');
      if (productUl) {
        const itemsArray = Array.from(productUl.querySelectorAll('.grid__item'));

        itemsArray.sort((a, b) => {
          const priceElA = a.querySelector('.price-item--sale, .price-item--regular, .price-item.price-item--regular');
          const priceElB = b.querySelector('.price-item--sale, .price-item--regular, .price-item.price-item--regular');

          const priceA = priceElA ? parseFloat(priceElA.textContent.replace(/[^0-9.]/g, '')) : 0;
          const priceB = priceElB ? parseFloat(priceElB.textContent.replace(/[^0-9.]/g, '')) : 0;

          return sortBy === 'price-ascending' ? priceA - priceB : priceB - priceA;
        });

        productUl.innerHTML = '';
        itemsArray.forEach(item => productUl.appendChild(item));
      }
    }
  }

  static renderProductCount(html = null) {
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    const gridContainer = document.getElementById('ProductGridContainer');

    let realTileCount = 0;
    if (gridContainer) {
      realTileCount = gridContainer.querySelectorAll('.grid__item:not([data-variant-hidden="true"])').length;
    }

    const customCountHTML = `<span id="ProductCountDesktop">${realTileCount} product${realTileCount !== 1 ? 's' : ''}</span>`;

    if (container) {
      container.innerHTML = customCountHTML;
      container.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = customCountHTML;
      containerDesktop.classList.remove('loading');
    }

    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static formatFacetHtml(cleanText, targetCount) {
    const sqftRegex = /(?:\(up to\s+)?(\d+\s*sqft)(?:\))?/i;
    const match = cleanText.match(sqftRegex);

    if (match) {
      const sqftPart = match[1].toLowerCase();

      let descriptiveName = cleanText
        .replace(sqftRegex, '')
        .replace(/\s*-\s*/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

      if (descriptiveName) {
        descriptiveName = descriptiveName.charAt(0).toUpperCase() + descriptiveName.slice(1);
        descriptiveName = descriptiveName.replace(/^[Mm]edium-sized\s+/, '').replace(/^[Ll]arge-sized\s+/, '');
      } else {
        descriptiveName = 'Residential';
      }

      return `<b>${sqftPart}</b> - ${descriptiveName} (${targetCount})`;
    }

    if (cleanText.includes(' - ')) {
      const textParts = cleanText.split(' - ');
      return `<b>${textParts[0].trim()}</b> - ${textParts[1].trim()} (${targetCount})`;
    }

    return `${cleanText} (${targetCount})`;
  }

  static initializeMasterLayoutCache() {
    FacetFiltersForm.initialCoverageCounts = {};

    const urlParams = new URLSearchParams(window.location.search);
    let hasActiveFilters = false;
    for (const key of urlParams.keys()) {
      if (key.startsWith('filter.')) {
        hasActiveFilters = true;
        break;
      }
    }

    if (!hasActiveFilters) {
      FacetFiltersForm.scanGridAndBuildCache(document);
      FacetFiltersForm.applyVariantLevelFilters();
    } else {
      const cleanFetchUrl = window.location.pathname;
      fetch(cleanFetchUrl)
        .then(response => response.text())
        .then(htmlText => {
          const parsingDoc = new DOMParser().parseFromString(htmlText, 'text/html');
          FacetFiltersForm.scanGridAndBuildCache(parsingDoc);
          FacetFiltersForm.applyVariantLevelFilters();
        })
        .catch(err => console.error('Error building master catalog cache:', err));
    }
  }

  static scanGridAndBuildCache(domTree) {
    const targetContext = domTree.getElementById('ProductGridContainer');
    if (!targetContext) return;

    const gridItems = targetContext.querySelectorAll('.grid__item');

    gridItems.forEach((item) => {
      const wrapper = item.querySelector('[data-variant-coverage]');
      let values = [];

      if (wrapper) {
        const rawCoverage = wrapper.getAttribute('data-variant-coverage') || '';
        values = rawCoverage.split('|').map(v => v.trim().toLowerCase()).filter(Boolean);
      } else {
        item.querySelectorAll('.main-collection-variants .product-form__input input').forEach((inp) => {
          values.push((inp.value || '').trim().toLowerCase());
        });
      }

      values.forEach((cleanValue) => {
        if (cleanValue) {
          FacetFiltersForm.initialCoverageCounts[cleanValue] =
            (FacetFiltersForm.initialCoverageCounts[cleanValue] || 0) + 1;
        }
      });
    });
  }

  static applyVariantLevelFilters() {
    const gridContainer = document.getElementById('ProductGridContainer');
    if (!gridContainer) return;

    const urlParams = new URLSearchParams(window.location.search);
    const activeCoverageValues = [];
    const activeAvailabilityValues = [];

    for (const [key, value] of urlParams.entries()) {
      if (key.toLowerCase().includes('coverage')) {
        activeCoverageValues.push(value.trim().toLowerCase());
      } else if (key === 'filter.v.availability') {
        activeAvailabilityValues.push(value.trim());
      }
    }

    const hasCoverageFilter = activeCoverageValues.length > 0;
    const hasAvailabilityFilter = activeAvailabilityValues.length > 0;
    const allItems = gridContainer.querySelectorAll('.grid__item');

    allItems.forEach((item) => {
      let coverageMatch = !hasCoverageFilter;
      if (hasCoverageFilter) {
        const wrapper = item.querySelector('[data-variant-coverage]');
        if (wrapper) {
          const rawCoverage = wrapper.getAttribute('data-variant-coverage') || '';
          const itemCoverageValues = rawCoverage.split('|').map(v => v.trim().toLowerCase()).filter(Boolean);
          coverageMatch = activeCoverageValues.some(filterVal =>
            itemCoverageValues.some(itemVal =>
              itemVal === filterVal || itemVal.includes(filterVal) || filterVal.includes(itemVal)
            )
          );
        } else {
          coverageMatch = FacetFiltersForm.checkVariantOptionMatchesCoverage(item, activeCoverageValues);
        }
      }

      let availabilityMatch = !hasAvailabilityFilter;
      if (hasAvailabilityFilter) {
        let selectedValuesArr = [];
        item.querySelectorAll('.main-collection-variants .product-form__input input').forEach(function(inp) {
          if (inp.checked) selectedValuesArr.push(inp.value.trim());
        });

        const exactCombinedName = selectedValuesArr.join(' / ');
        let selectedVariantAvail = null;

        if (exactCombinedName) {
          const selectedOpt = item.querySelector(`.main-collection-variants .hidden-collection-variants option[value="${exactCombinedName}"]`);
          if (selectedOpt) selectedVariantAvail = selectedOpt.getAttribute('variants-avail');
        }

        if (selectedVariantAvail === null && selectedValuesArr.length === 1) {
          const selectedOpt = item.querySelector(`.main-collection-variants .hidden-collection-variants option[value="${selectedValuesArr[0]}"]`);
          if (selectedOpt) selectedVariantAvail = selectedOpt.getAttribute('variants-avail');
        }

        if (selectedVariantAvail === null) {
          const firstOpt = item.querySelector('.main-collection-variants .hidden-collection-variants option');
          if (firstOpt) selectedVariantAvail = firstOpt.getAttribute('variants-avail');
        }

        const isItemInStock = selectedVariantAvail !== 'false';
        availabilityMatch = activeAvailabilityValues.some(filterVal => {
          if (filterVal === '1') return isItemInStock;
          if (filterVal === '0') return !isItemInStock;
          return false;
        });
      }

      if (coverageMatch && availabilityMatch) {
        item.removeAttribute('data-variant-hidden');
        item.style.display = '';
      } else {
        item.setAttribute('data-variant-hidden', 'true');
        item.style.display = 'none';
      }
    });

    FacetFiltersForm.renderProductCount();
    FacetFiltersForm.updateCheckboxFacetCounts();
  }

  static checkVariantOptionMatchesCoverage(item, activeCoverageValues) {
    let matched = false;
    item.querySelectorAll('.main-collection-variants .product-form__input input').forEach(function(inp) {
      if (inp.checked) {
        const val = (inp.value || '').trim().toLowerCase();
        if (activeCoverageValues.some(fv => val.includes(fv) || fv.includes(val))) matched = true;
      }
    });
    if (!matched) {
      item.querySelectorAll('.main-collection-variants .hidden-collection-variants option').forEach(function(opt) {
        const val = (opt.value || '').trim().toLowerCase();
        if (activeCoverageValues.some(fv => val.includes(fv) || fv.includes(val))) matched = true;
      });
    }
    return matched;
  }

  static fetchAndUpdateAvailabilityCounts() {
    const urlParams = new URLSearchParams(window.location.search);
    const filteredParams = new URLSearchParams();
    for (const [key, value] of urlParams.entries()) {
      if (key !== 'filter.v.availability') {
        filteredParams.append(key, value);
      }
    }

    const cacheKey = filteredParams.toString();

    if (
      FacetFiltersForm.availabilityCountCache &&
      FacetFiltersForm.availabilityCountCache.key === cacheKey
    ) {
      const { inStock, outOfStock } = FacetFiltersForm.availabilityCountCache.counts;
      FacetFiltersForm.renderAvailabilityCounts(inStock, outOfStock);
      return;
    }

    const gridEl = document.getElementById('product-grid');
    const sectionId = gridEl ? gridEl.dataset.id : '';
    const fetchUrl = `${window.location.pathname}?section_id=${sectionId}&${cacheKey}`;

    fetch(fetchUrl)
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const gridContainer = doc.getElementById('ProductGridContainer');

        let inStock = 0;
        let outOfStock = 0;

        if (gridContainer) {
          const activeCoverageValues = [];
          for (const [key, value] of urlParams.entries()) {
            if (key.toLowerCase().includes('coverage')) {
              activeCoverageValues.push(value.trim().toLowerCase());
            }
          }

          gridContainer.querySelectorAll('.grid__item').forEach(item => {
            let coverageMatch = activeCoverageValues.length === 0;

            if (activeCoverageValues.length > 0) {
              const wrapper = item.querySelector('[data-variant-coverage]');
              if (wrapper) {
                const rawCoverage = wrapper.getAttribute('data-variant-coverage') || '';
                const itemVals = rawCoverage.split('|').map(v => v.trim().toLowerCase()).filter(Boolean);
                coverageMatch = activeCoverageValues.some(fv =>
                  itemVals.some(iv => iv === fv || iv.includes(fv) || fv.includes(iv))
                );
              } else {
                coverageMatch = FacetFiltersForm.checkVariantOptionMatchesCoverage(item, activeCoverageValues);
              }
            }

            if (!coverageMatch) return;

            let selectedValuesArr = [];
            item.querySelectorAll('.main-collection-variants .product-form__input input').forEach(inp => {
              if (inp.checked) selectedValuesArr.push(inp.value.trim());
            });

            const exactCombinedName = selectedValuesArr.join(' / ');
            let matchedOpt = null;

            if (exactCombinedName) {
              matchedOpt = item.querySelector(
                `.main-collection-variants .hidden-collection-variants option[value="${exactCombinedName}"]`
              );
            }
            if (!matchedOpt && selectedValuesArr.length === 1) {
              matchedOpt = item.querySelector(
                `.main-collection-variants .hidden-collection-variants option[value="${selectedValuesArr[0]}"]`
              );
            }
            if (!matchedOpt) {
              matchedOpt = item.querySelector(
                '.main-collection-variants .hidden-collection-variants option'
              );
            }

            const isAvailable = matchedOpt
              ? matchedOpt.getAttribute('variants-avail') !== 'false'
              : true;

            if (isAvailable) inStock++;
            else outOfStock++;
          });
        }

        FacetFiltersForm.availabilityCountCache = {
          key: cacheKey,
          counts: { inStock, outOfStock }
        };

        // ✅ FIXED FOR BOTH LAYOUTS: Disables out of stock filters dynamically on Desktop AND Mobile wrappers
        if (outOfStock == 0) {
          $("li.availibility_filters_wrap.list-menu__item.facets__item").eq(1).addClass('facet-checkbox--disabled');
          $(".mobile-facets__main li.mobile-facets__item, .mobile-facets__main .list-menu__item").each(function() {
            const labelText = $(this).find('.mobile-facets__label').text().toLowerCase();
            if (labelText.includes('out of stock')) {
              $(this).addClass('facet-checkbox--disabled');
            }
          });
        } else {
          $("li.availibility_filters_wrap.list-menu__item.facets__item").eq(1).removeClass('facet-checkbox--disabled');
          $(".mobile-facets__main li.mobile-facets__item, .mobile-facets__main .list-menu__item").each(function() {
            const labelText = $(this).find('.mobile-facets__label').text().toLowerCase();
            if (labelText.includes('out of stock')) {
              $(this).removeClass('facet-checkbox--disabled');
            }
          });
        }

        FacetFiltersForm.renderAvailabilityCounts(inStock, outOfStock);
      })
      .catch(err => console.error('Error fetching availability counts:', err));
  }

  static renderAvailabilityCounts(inStock, outOfStock) {
    document.querySelectorAll(
      '.facet-checkbox input[type="checkbox"], .facet-checkbox input[type="radio"], .mobile-facets__checkbox input[type="checkbox"], .mobile-facets__checkbox'
    ).forEach(checkbox => {
      const labelElement = checkbox.closest('.facet-checkbox') || checkbox.closest('.mobile-facets__label');
      if (!labelElement) return;

      const targetSpans = labelElement.querySelectorAll(
        '.facet-checkbox__text, .mobile-facets__label > span:not(.visually-hidden), span:not(.visually-hidden):not(.true-liquid-count)'
      );

      targetSpans.forEach(span => {
        let cleanText = span.textContent
          .replace(/\s*\(\d+\)\s*$/, '')
          .replace(/\s*\(\d+\s*product.*\)\s*$/, '')
          .trim();
        if (!cleanText) return;

        const lowerText = cleanText.toLowerCase();
        if (lowerText === 'in stock') {
          span.innerHTML = FacetFiltersForm.formatFacetHtml(cleanText, inStock);
        } else if (lowerText === 'out of stock') {
          span.innerHTML = FacetFiltersForm.formatFacetHtml(cleanText, outOfStock);
        }
      });
    });
  }

  static updateCheckboxFacetCounts() {
    const gridContainer = document.getElementById('ProductGridContainer');
    if (!gridContainer) return;

    const allCheckboxes = document.querySelectorAll(
      '.facet-checkbox input[type="checkbox"], .facet-checkbox input[type="radio"], .mobile-facets__checkbox'
    );

    const urlParams = new URLSearchParams(window.location.search);
    const hasAvailabilityFilter = [...urlParams.keys()].some(k => k === 'filter.v.availability');

    if (hasAvailabilityFilter) {
      FacetFiltersForm.fetchAndUpdateAvailabilityCounts();
    } else {
      FacetFiltersForm.fetchAndUpdateAvailabilityCounts();

      let inStockCount = 0;
      let outOfStockCount = 0;

      gridContainer.querySelectorAll('.grid__item').forEach((item) => {
        let matchesCoverageScope = true;
        const activeCoverageValues = [];

        for (const [key, value] of urlParams.entries()) {
          if (key.toLowerCase().includes('coverage')) {
            activeCoverageValues.push(value.trim().toLowerCase());
          }
        }

        if (activeCoverageValues.length > 0) {
          const wrapper = item.querySelector('[data-variant-coverage]');
          if (wrapper) {
            const rawCoverage = wrapper.getAttribute('data-variant-coverage') || '';
            const itemCoverageValues = rawCoverage.split('|').map(v => v.trim().toLowerCase()).filter(Boolean);
            matchesCoverageScope = activeCoverageValues.some(filterVal =>
              itemCoverageValues.some(itemVal =>
                itemVal === filterVal || itemVal.includes(filterVal) || filterVal.includes(itemVal)
              )
            );
          } else {
            matchesCoverageScope = FacetFiltersForm.checkVariantOptionMatchesCoverage(item, activeCoverageValues);
          }
        }

        if (!matchesCoverageScope) return;

        let selectedValuesArr = [];
        item.querySelectorAll('.main-collection-variants .product-form__input input').forEach(function(inp) {
          if (inp.checked) selectedValuesArr.push(inp.value.trim());
        });

        const exactCombinedName = selectedValuesArr.join(' / ');
        let matchedOpt = null;

        if (exactCombinedName) {
          matchedOpt = item.querySelector(`.main-collection-variants .hidden-collection-variants option[value="${exactCombinedName}"]`);
        }
        if (!matchedOpt && selectedValuesArr.length === 1) {
          matchedOpt = item.querySelector(`.main-collection-variants .hidden-collection-variants option[value="${selectedValuesArr[0]}"]`);
        }

        let isAvailable = true;
        if (matchedOpt) {
          isAvailable = matchedOpt.getAttribute('variants-avail') !== 'false';
        } else {
          const badgeSoldOut = item.querySelector('.card__badge-soldout');
          const soldOutSpan = item.querySelector('.sold-out-badge');
          if ((badgeSoldOut && window.getComputedStyle(badgeSoldOut).display !== 'none') || soldOutSpan) {
            isAvailable = false;
          } else {
            const firstOpt = item.querySelector('.main-collection-variants .hidden-collection-variants option');
            if (firstOpt) isAvailable = firstOpt.getAttribute('variants-avail') !== 'false';
          }
        }

        if (isAvailable) inStockCount++;
        else outOfStockCount++;
      });

      FacetFiltersForm.renderAvailabilityCounts(inStockCount, outOfStockCount);
    }

    allCheckboxes.forEach((checkbox) => {
      const labelElement = checkbox.closest('.facet-checkbox') || checkbox.closest('.mobile-facets__label');
      if (!labelElement) return;

      const checkboxValue = (checkbox.value || '').trim().toLowerCase();
      const targetSpans = labelElement.querySelectorAll(
        '.facet-checkbox__text, .mobile-facets__label > span:not(.visually-hidden), span:not(.visually-hidden):not(.true-liquid-count)'
      );

      targetSpans.forEach((span) => {
        let cleanText = span.textContent
          .replace(/\s*\(\d+\)\s*$/, '')
          .replace(/\s*\(\d+\s*product.*\)\s*$/, '')
          .trim();
        if (!cleanText) return;

        const lowerText = cleanText.toLowerCase();

        if (lowerText.includes('acre') || lowerText.includes('sqft') || lowerText.includes(' - ')) {
          let staticCount = 0;

          if (FacetFiltersForm.initialCoverageCounts) {
            if (checkboxValue && FacetFiltersForm.initialCoverageCounts[checkboxValue] !== undefined) {
              staticCount = FacetFiltersForm.initialCoverageCounts[checkboxValue];
            } else if (FacetFiltersForm.initialCoverageCounts[lowerText] !== undefined) {
              staticCount = FacetFiltersForm.initialCoverageCounts[lowerText];
            }
          }

          span.innerHTML = FacetFiltersForm.formatFacetHtml(cleanText, staticCount);
        }
      });
    });
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const targetElement = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if (targetElement) {
        targetElement.innerHTML = element.innerHTML;
        if (element.classList.contains('active_filter')) {
          targetElement.classList.add('active_filter');
        } else {
          targetElement.classList.remove('active_filter');
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilter = event.target.closest('.js-filter');
      const closestJSFilterID = closestJSFilter ? closestJSFilter.id : null;

      if (closestJSFilterID) {
        if (countsToRender.classList.contains('active_filter')) {
          closestJSFilter.classList.add('active_filter');
        } else {
          closestJSFilter.classList.remove('active_filter');
        }

        FacetFiltersForm.renderCounts(countsToRender, closestJSFilter);
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newElementSelector = document
          .getElementById(closestJSFilterID)
          .classList.contains('mobile-facets__details')
          ? `#${closestJSFilterID} .mobile-facets__close-button`
          : `#${closestJSFilterID} .facets__summary`;
        const newElementToActivate = document.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      const targetElement = document.querySelector(selector);
      if (targetElement) targetElement.innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      const targetElement = document.querySelector(selector);
      if (targetElement) targetElement.innerHTML = html.querySelector(selector).innerHTML;
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileForm && mobileForm.closest('menu-drawer')) {
      mobileForm.closest('menu-drawer').bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');
    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');
    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');
    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }
      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');
    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
    FacetFiltersForm.updateCheckboxFacetCounts();
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const gridEl = document.getElementById('product-grid');
    return [
      {
        section: gridEl ? gridEl.dataset.id : '',
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const currentForm = event.target.closest('form');
      const isMobile = currentForm && currentForm.id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.initialized = false;
FacetFiltersForm.initialCoverageCounts = null;
FacetFiltersForm.availabilityCountCache = null; 
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', maxInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', minInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);